import styled from 'styled-components'

import { PriceStyled } from '@webapp/core/components/Price/styles/PriceStyled'

interface ICurrencyConversionInfoStyledProps {}

export const CurrencyConversionInfoStyled = styled.div<ICurrencyConversionInfoStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  ${PriceStyled} {
    text-align: right;
  }
`
